const instancesServer = {
    localhost : 'https://staging.safefleet.eu',
    staging   : 'https://staging.safefleet.eu',
    alpha     : 'https://alpha.safefleet.eu',
    austria   : 'https://austria.safefleet.eu',
    cacttus   : 'https://cacttus.safefleet.eu',
    citone    : 'https://citone.safefleet.eu',
    delta     : 'https://delta.safefleet.eu',
    electrica : 'https://electrica.safefleet.eu',
    eta       : 'https://eta.safefleet.eu',
    eulex     : 'https://eulex.safefleet.eu',
    galignum  : 'https://galignum.safefleet.eu',
    gamma     : 'https://gamma.safefleet.eu',
    ins       : 'https://ins.safefleet.eu',
    ins2      : 'https://ins2.safefleet.eu',
    italy     : 'https://portale.safefleet.it',
    launchpad : 'https://launchpad.safefleet.eu',
    merrion   : 'https://merrion.safefleet.eu',
    mifra     : 'https://mifra.safefleet.it',
    osce2     : 'https://osce2.safefleet.eu',
    plose     : 'https://plose.safefleet.eu',
    poland    : 'https://portal.safefleet.pl',
    poland2   : 'https://poland2.safefleet.eu',
    portale2  : 'https://portale2.safefleet.eu',
    tanzania  : 'https://tanzania.safefleet.eu',
    telekom   : 'https://telekom.safefleet.eu',
    veolia    : 'https://veolia-cloud.safefleet.eu',
}

export default instancesServer
